module.exports = __webpack_public_path__ + "img/horizontal_4_2_pp2_3016.43dbe091.png";